import { Button } from '@mui/material'
import { useAuthContext } from 'components/context/AuthProvider'
import { UIModal } from 'features/UI'
import { useShowControl } from 'hooks/useShowControl'
import React from 'react'
import { TimelineTeamFormAdd } from './TimelineTeamFormAdd'

export function TimelineTeamControlAdd() {
  const { isSharingEnabled } = useAuthContext()
  const [isOpen, handleOpen, handleClose] = useShowControl()

  return (
    <>
      <Button
        variant="contained"
        sx={{ width: '120px' }}
        disabled={!isSharingEnabled}
        onClick={handleOpen}
      >
        Add Team
      </Button>

      <UIModal title="Add Team" isOpen={isOpen} onClose={handleClose}>
        <TimelineTeamFormAdd onClose={handleClose} />
      </UIModal>
    </>
  )
}
